import { Component } from "@angular/core";
import { TranslationService } from "../../_services/translation.service";
import { ITranslations } from "../../_models/ITranslations";
import { Observable } from "rxjs/Observable";

@Component({
  selector: "app-loading-data",
  template: `
    <div class="w-full min-h-32  flex flex-col justify-center items-center">
      <app-spinner></app-spinner>
      <div class="mt-3">
        {{ (translations$ | async).loading_data }}<span>...</span>
      </div>
    </div>
  `,
  styleUrls: ["./app-loading-data.component.scss"],
})
export class AppLoadingDataComponent {
  public translations$: Observable<ITranslations>;
  constructor(private translationService: TranslationService) {
    this.translations$ = this.translationService.translations;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/app-loading-data/app-loading-data.component.ts